import { isPlatformBrowser } from '@angular/common';

import { WindowService } from '../../shared/services/window.service';

// TODO: make this async and call all required crypto functions on some test data
// to make sure all algorithms we require are supported.
export function cryptoApiAvailableFactory(
    windowService: WindowService,
    platformId: object
) {
    if (!isPlatformBrowser(platformId)) {
        return false;
    }

    const cryptoApi = windowService.nativeWindow.crypto;

    if (!cryptoApi) {
        return false;
    }

    if (!cryptoApi.getRandomValues) {
        return false;
    }

    const subtleCrypto = cryptoApi.subtle;

    if (!subtleCrypto) {
        return false;
    }

    const requiredOperations: ReadonlyArray<string> = [
        'encrypt',
        'decrypt',
        'importKey',
        'digest'
    ];

    for (const operation of requiredOperations) {
        if (!(operation in subtleCrypto)) {
            return false;
        }
    }

    return true;
}
